/**
 * Created by Alican Köker
 * on 2018/02/07.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite, TweenMax} from "gsap";
import {WildNudgeGameConfig} from "../../../WildNudgeGameConfig";
import DisplayObject = PIXI.DisplayObject;
import {WildNudgeIntroConfig} from "../../../intro/WildNudgeIntroConfig";

export class BackgroundAnimationsView extends BaseView {

    private _foregroundAnimationsLayer:PIXI.Container;
    private _spotlightLayer:PIXI.Container;

    private _spinAnimTimeline:TimelineLite;
    private _winAnimsTimeline:TimelineLite;
    private _noWinSteamAnimTimeline:TimelineLite;

    private _isSpinSteamPlaying:boolean = false;

    private _components:PIXI.Sprite[];
    private _compPositions:number[][] = [[65, 516], [114, 335], [512, -78], [1098, 234], [1152, 500]];
    private _steamAnimations:TimelineSprite[];
    private _steamPositions:number[][] = [[354, -213], [1110, 355]];
    private _noWinSteamAnimations:TimelineSprite[];
    private _noWinSteamPositions:number[][] = [[334, 530], [490, 530], [646, 530], [802, 530], [958, 530]];

    private _gameLogo:PIXI.Sprite;

    private _redFlashLightTimeline:TimelineLite;
    private _redFlashLightContainer:PIXI.Container = new PIXI.Container();
    private _redFlashLightPositions:number[][] = [[-980, -120], [160, -120]];
    private _redFlashLights:TimelineSprite[] = [];
    private _flashLightsLit:boolean = false;
    private _flashLightNamePrefix:string = "redFlashLight";

    private _shakingTweens:TweenMax[] = [];


    constructor() {
        super();

        this._foregroundAnimationsLayer = StageManager.getLayer(WildNudgeGameConfig.instance.LAYERS.FORGROUND_ANIMATIONS.name);
        this._spotlightLayer = StageManager.getLayer(WildNudgeGameConfig.instance.LAYERS.SPOT_LIGHTS.name);
        this._redFlashLightContainer = new PIXI.Container();
    }

    public startSpinSteamAnimations():void {
        if(!this._isSpinSteamPlaying) {
            this._isSpinSteamPlaying = true;
            this._spinAnimTimeline = new TimelineLite({paused : true});
            this._spinAnimTimeline.add([
                () => this._steamAnimations[0].alpha = 1,
                () => this._steamAnimations[1].alpha = 1,
                () => this._steamAnimations[0].getAnimation().play(),
                () => this._steamAnimations[1].getAnimation().play(),
            ]);
            this._spinAnimTimeline.add(
                () => {
                    this.toggleSpinAnimFlag();
                    TweenLite.to(this._steamAnimations[0], 0.5, {alpha : 0});
                    TweenLite.to(this._steamAnimations[1], 0.5, {alpha : 0});
                }, this._steamAnimations[1].getAnimation().duration());

            this._spinAnimTimeline.play();
        }
    }

    private shakeObjects():void {
        this._shakingTweens = [];
        this._components.forEach((target:PIXI.Sprite) =>
            this._shakingTweens.push(TweenMax.to(target, 0.1, {x : "-=1", repeat : -1, yoyo : true}))
        )
    }

    public playNoWinSteamAnimation(index:number):void {
        this._noWinSteamAnimTimeline = new TimelineLite();
        this._noWinSteamAnimTimeline.add([
            () => this._noWinSteamAnimations[index].alpha = 1,
            () => this._noWinSteamAnimations[index].getAnimation().play(),
        ]);

        this._noWinSteamAnimTimeline.add(
            () => {
                this.toggleSpinAnimFlag();
                TweenLite.to(this._noWinSteamAnimations[index], 0.5, {alpha : 0});
            }, this._noWinSteamAnimations[index].getAnimation().duration());

        this._noWinSteamAnimTimeline.play();
    }

    public startShaking():void {
        this.shakeObjects();
    }

    private toggleSpinAnimFlag():void {
        this._isSpinSteamPlaying = !this._isSpinSteamPlaying;
    }

    protected initAnimations():void {

        //shaking parts
        this._components = [];
        for(let i:number = 0; i < 5; i++) {
            this._components.push(new PIXI.Sprite(GameResources.getTextures("component" + (i + 1).toString())[0]));
            this._components[i].position.set(this._compPositions[i][0], this._compPositions[i][1]);
        }

        //steam animations to use during spin and win state
        this._steamAnimations = [];
        for(let i:number = 0; i < 2; i++) {
            this._steamAnimations.push(new TimelineSprite(GameResources.getTextures("steam")));
            this._steamAnimations[i].position.set(this._steamPositions[i][0], this._steamPositions[i][1]);
            this._steamAnimations[i].blendMode = PIXI.BLEND_MODES.ADD;
            this._steamAnimations[i].stopLoop();
            this._steamAnimations[i].alpha = 0;
        }

        this._steamAnimations[1].pivot.set(this._steamAnimations[1].width / 2, this._steamAnimations[1].height / 2);

        //steam animations for stacked symbol anticipation - to use in no win state
        this._noWinSteamAnimations = [];

        for(let i:number = 0; i < 5; i++) {
            this._noWinSteamAnimations.push(new TimelineSprite(GameResources.getTextures("steam")));
            this._noWinSteamAnimations[i].position.set(this._noWinSteamPositions[i][0], this._noWinSteamPositions[i][1]);
            this._noWinSteamAnimations[i].pivot.set(this._noWinSteamAnimations[i].width / 2, this._noWinSteamAnimations[i].height / 2);
            this._noWinSteamAnimations[i].blendMode = PIXI.BLEND_MODES.ADD;
            this._noWinSteamAnimations[i].stopLoop();
            this._noWinSteamAnimations[i].alpha = 0;
        }

        //game logo
        this._gameLogo = new PIXI.Sprite(GameResources.getTextures(WildNudgeIntroConfig.INTRO_LOGO)[0]);
        this._gameLogo.scale.set(0.7, 0.7);
        this._gameLogo.position.set(707, -7);

        this.createFlashLights();

        //added to different layers
        this._spotlightLayer.addChild(this._components[0]);
        this.addChild(this._components[1]);
        this._spotlightLayer.addChild(this._components[2]);
        this.addChild(this._components[3]);
        this._spotlightLayer.addChild(this._components[4]);

        this.addChild(this._steamAnimations[0]);
        this.addChild(this._steamAnimations[1]);
        this.addChild(this._gameLogo);

        for(let i = 0; i < 5; i++)
            this.addChild(this._noWinSteamAnimations[i]);

        this._winAnimsTimeline = new TimelineLite();
        this._foregroundAnimationsLayer.addChild(this);
    }

    public setRedFlashAnimations(args:{ val:boolean, fps?:number | undefined }):void {
        if(args.val) {
            this.createFlashLights(args.fps!);
            TweenLite.to(this._redFlashLightContainer, 0.4, {alpha : 1});
            this._redFlashLightTimeline.play();
        } else {
            TweenLite.to(this._redFlashLightContainer, 0.4, {alpha : 0});
            this._redFlashLightTimeline.pause();
        }

        this._flashLightsLit = args.val;
    }

    private createFlashLights(fps?:number):void {
        let child:DisplayObject = this.getChildByName("flashLightContainer");
        if(child) {
            this.removeChild(child);
        }

        this._redFlashLightContainer.name = "flashLightContainer";

        this._redFlashLightTimeline = new TimelineLite();
        this._redFlashLightContainer.removeChildren();
        this._redFlashLights = [];

        for(let i:number = 0; i < 2; i++) {
            let tl:TimelineSprite = new TimelineSprite(GameResources.getTextures(this._flashLightNamePrefix), fps);
            this._redFlashLights.push(tl);
            this._redFlashLights[i].blendMode = PIXI.BLEND_MODES.ADD;
            this._redFlashLights[i].position.set(this._redFlashLightPositions[i][0], this._redFlashLightPositions[i][1]);
            this._redFlashLights[i].scale.set(1.7);

            this._redFlashLightTimeline.add(
                () => this._redFlashLights[i].playLoop(),
                0.2 * i
            );
            this._redFlashLightContainer.addChild(this._redFlashLights[i]);
        }

        this._redFlashLightContainer.alpha = 0;

        this.addChild(this._redFlashLightContainer);
    }

    public stopShaking():void {
        this._shakingTweens.forEach((tween:TweenMax) => tween.kill());
        for(let i:number = 0; i < 5; i++) {
            this._components[i].position.set(this._compPositions[i][0], this._compPositions[i][1]);
        }
    }
}